import { render } from "./Leads.vue?vue&type=template&id=726859a5&scoped=true&ts=true"
import script from "./Leads.vue?vue&type=script&lang=ts"
export * from "./Leads.vue?vue&type=script&lang=ts"

import "./Leads.vue?vue&type=style&index=0&id=726859a5&scoped=true&lang=css"

import exportComponent from "/Users/andrea/Sites/app_v2/app_seilatv/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-726859a5"]])

export default __exports__